/**
 * Extract section-specific summaries from AI recommendation text
 */
export const extractSectionSummaries = (aiRecommendation) => {
  if (!aiRecommendation) {
    return { logic: null, universe: null, vibe: null, synthesis: aiRecommendation };
  }

  const paragraphs = aiRecommendation.split('\n\n');
  
  let logicSummary = null;
  let universeSummary = null;
  let vibeSummary = null;
  const remainingParagraphs = [];

  paragraphs.forEach(para => {
    const lowerPara = para.toLowerCase();
    
    if (lowerPara.startsWith('your logic shows') || lowerPara.startsWith('your logic says')) {
      logicSummary = para;
    } else if (lowerPara.startsWith('the universe is') || (lowerPara.startsWith('the universe') && lowerPara.includes('showing'))) {
      universeSummary = para;
    } else if (lowerPara.startsWith('your body says') || lowerPara.startsWith('your vibe says') || lowerPara.startsWith('your body/heart says')) {
      vibeSummary = para;
    } else {
      // Keep for main synthesis
      remainingParagraphs.push(para);
    }
  });

  return {
    logic: logicSummary,
    universe: universeSummary,
    vibe: vibeSummary,
    synthesis: remainingParagraphs.join('\n\n')
  };
};
